var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("van-field", {
        class: {
          "field-focus-border": _vm.isFocus,
          "field-border": !_vm.isFocus
        },
        attrs: {
          value: _vm.value,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          border: _vm.border,
          clearable: _vm.clearable,
          rules: _vm.rules,
          placeholder: _vm.placeholder,
          name: _vm.name
        },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          },
          focus: _vm.focus,
          blur: _vm.blur
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-83acec68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83acec68","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InscriptionArea/compontents/cuField.vue
// module id = 9cqm
// module chunks = 0